import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { InjectionToken, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { globalConfig } from './global.config';
import { MpsAppComponent } from './mps/components/mps-app/mps-app.component';

registerLocaleData(localeFr); // MPS TODO: Adapt to your locale

export const OAUTH2_PROVIDERS_URL = new InjectionToken<string>('OAUTH2_PROVIDERS_URL');
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
export const LOADER_ON_HTTP = new InjectionToken<string>('LOADER_ON_HTTP');

bootstrapApplication(MpsAppComponent, {
  ...globalConfig,
  providers: [provideZoneChangeDetection(), ...globalConfig.providers],
}).catch((err) => console.error(err));
